import React from 'react';


interface ContentProps {
    content: any;
}

export const ProfileContent: React.FC<ContentProps> = ({ content }) => {
    return <>{content()}</>;
};
